import React from 'react';

const EditGeneralInformation = () => {
    return <div>EditGeneralInformation</div>;
};

export default EditGeneralInformation;
